import { render, staticRenderFns } from "./ShopsSlider.vue?vue&type=template&id=6c310c10&"
import script from "./ShopsSlider.vue?vue&type=script&lang=js&"
export * from "./ShopsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports